<div id="accept-modal">
  <span class="close-button" [mat-dialog-close] style="float: right; margin-right: -15px;" *ngIf="dialogResponse?.isClose">
    <img src="./assets/icons/icon_close.svg" alt="close">
</span>
  <div class="accept-content">
    
    <div class="modal-title">
      <h2>{{dialogResponse?.title|translate}}</h2>
    </div>
    <div class="accept-modal-body" [class.partsColor] = "dialogResponse.hasOrderParts">
      {{dialogResponse?.body|translate}}<span *ngIf="dialogResponse?.body_2"><br>{{dialogResponse?.body_2|translate}}</span>
      <div class="subtitle" *ngIf="dialogResponse?.response">
        <strong> {{dialogResponse?.response?.customer || dialogResponse?.response?.customer_name|translate}} - {{dialogResponse?.response?.model_name|translate}} <span *ngIf="dialogResponse?.isSN">- {{dialogResponse?.response?.serial_number}}</span></strong>
     </div>
    </div>

  </div>

  <div class="footer" *ngIf="!dialogResponse.hasOrderParts">
    <ng-container *ngIf="!dialogResponse?.isOkay&&dialogResponse?.true==undefined && showButtons">
      <div>
        <button id="accept-modal-cancel-btn" [mat-dialog-close] = "false" class="hp-secondary-btn btn-space-left">{{'BUTTONS.CANCEL' | translate}}</button>
      </div>
      <div>
        <button id="accept-modal-delete-btn" [mat-dialog-close] = "true" class="hp-primary-btn btn-space-left delete-icon">
          <img class="delete-icon" src="./assets/icons/delete_site_white.svg" alt="delete-site">
          <span>{{'BUTTONS.DELETE' | translate}}</span>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="!dialogResponse?.isOkay&&dialogResponse?.true!==undefined">
      <div>
        <button id="accept-modal-false-btn" [mat-dialog-close] = "false" class="hp-secondary-btn btn-space-left">{{dialogResponse?.false|translate}}</button>
      </div>
      <div>
        <button id="accept-modal-true-btn" [mat-dialog-close] = "true" class="hp-primary-btn btn-space-left">{{dialogResponse?.true|translate}}</button>
      </div>
    </ng-container>

    <ng-container *ngIf="dialogResponse?.isOkay">
      <div>
        <button id="accept-modal-continue-btn" *ngIf="dialogResponse.customString != null" [mat-dialog-close] = "true" class="hp-primary-btn auto btn-space-left">{{'CONTINUE' | translate}}</button>
        <button id="accept-modal-okay-btn" *ngIf="dialogResponse.customString == null" [mat-dialog-close] = "true" class="hp-primary-btn auto btn-space-left">{{'BUTTONS.OKAY' | translate}}</button>
      </div>
    </ng-container>
  </div>

  <div class="footer" *ngIf="dialogResponse.hasOrderParts">
    <div>
      <button id="accept-modal-gotocsdp-btn" [mat-dialog-close] = "'orderParts'" class="hp-secondary-btn btn-space-left">{{'GOTOCSDP' | translate}}</button>
    </div>
    <div>
      <button id="accept-modal-done-btn" [mat-dialog-close] = "true" class="hp-primary-btn auto btn-space-left">{{'BUTTONS.DONE' | translate}}</button>
    </div>
  </div>
</div>

